import React, { useEffect, useState } from "react";
import { StyleSheet, View } from "react-native-web";
import Select from "react-select";
//icons
import { RiArrowDownSLine } from "react-icons/ri";

const Dropdown = (props) => {
  const {
    list = [],
    placeholder,
    disable = false,
    style,
    value,
    valueType,
    findWithId,
  } = props;
  const { onChange, onInputChange } = props;

  const [selectValue, setSelectValue] = useState();

  useEffect(() => {
    if (value !== null && value !== undefined && list.length > 0 && valueType) {
      if (findWithId) {
        let check =
          valueType === "string"
            ? list.filter((d) => {
                return String(d.id) === String(value);
              })
            : list.filter((d) => {
                return Number(d.id) === Number(value);
              });
        if (check.length > 0) {
          setSelectValue(check[0]);
        }
      } else {
        // console.log(placeholder, value, valueType);
        let check =
          valueType === "string"
            ? list.filter((d) => {
                return String(d.value) === String(value);
              })
            : list.filter((d) => {
                return Number(d.value) === Number(value);
              });
        if (check.length > 0) {
          setSelectValue(check[0]);
        }
      }
    } else if (!value && list && valueType) {
      setSelectValue(null);
    }
  }, [value,list]);

  /*useEffect(() => {
    if (list.length <= 0) {
      setSelectValue(null);
    }
  }, [list]);*/

  const [debounceTimeout, setDebounceTimeout] = useState(null);

  const handleInputChange = (value) => {
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }
    const newTimeout = setTimeout(() => {
      onInputChange && onInputChange(value);
    }, 1000); // 1000 ms delay

    setDebounceTimeout(newTimeout);
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 50,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
    }),
  };

  return (
    <View style={{ flex: 1, zIndex: 99999, ...style }}>
      <Select
        value={selectValue}
        options={list ? list : []}
        placeholder={placeholder ? placeholder : ""}
        isDisabled={disable}
        components={{
          DropdownIndicator: () => (
            <RiArrowDownSLine
              style={{
                ...Styles.dropdownIcon,
                color: disable ? "#8A91A1" : "#0F1011",
              }}
            />
          ),
          IndicatorSeparator: () => null,
        }}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: "#FFD7D7",
            primary: "#DE7C78",
          },
        })}
        onInputChange={handleInputChange}
        onChange={(values) => {
          console.log("on select", values);
          onChange && onChange(values);
        }}
        autoFocus={false}
        styles={customStyles}
      ></Select>
    </View>
  );
};

/*
  styles={{
    control: (provided, state) => ({
      ...provided,
      boxShadow: "none",
      border: state.isFocused && "none"
    }),
    menu: (provided, state) => ({
      ...provided,
      border: "none",
      boxShadow: "none"
    }),
    option: (provided, state) => ({
       ...provided,
       backgroundColor: state.isFocused && "lightgray",
       color: state.isFocused && "red"
    })
  }}
*/

const Styles = StyleSheet.create({
  dropdownIcon: {
    position: "absolute",
    fontSize: 20,
    color: "#0F1011",
    right: 8,
  },
});

export default Dropdown;
